module.exports = __webpack_public_path__ + "media/bethOnLaptopBackground.2f8b5db6.png";